import { render, staticRenderFns } from "./exhibitionAdd.vue?vue&type=template&id=3308a5ac&scoped=true&"
import script from "./exhibitionAdd.vue?vue&type=script&lang=js&"
export * from "./exhibitionAdd.vue?vue&type=script&lang=js&"
import style0 from "./exhibitionAdd.vue?vue&type=style&index=0&id=3308a5ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3308a5ac",
  null
  
)

export default component.exports